import { DaycareAvailabilityRoom } from 'types/Availability';
import { Room } from 'types/Room';

export const convertAvailabilityRoomToRoom = (room: DaycareAvailabilityRoom): Room => {
    return {
        id: room.id,
        name: room.name,
        photos: [],
        pet_type_list: room.petTypeList,
        room_units: room.roomUnits
            .filter(roomUnit => roomUnit.available)
            .map(roomUnit => ({
                id: roomUnit.id,
                uuid: '',
                name: roomUnit.name,
                active: true,
                available: roomUnit.available,
                occupancy: roomUnit.occupancy,
                activeSizeRuleId: roomUnit.activeSizeRuleId,
                sizeEligibility: roomUnit.sizeEligibility
            })),
        room_rules: room.roomRules,
        restrictedCatBreedList: room.restrictedCatBreedList,
        restrictedDogBreedList: room.restrictedDogBreedList,
        restrictedPetTagList: room.restrictedPetTagList,
        staffIds: []
    };
};
